/**
 * @fileoverview Estilos do UserScheduleField (aba "Horários" do UserEditorModal).
 * Só makeStyles — sem lógica. Extraído de index.js para manter cada arquivo
 * com uma responsabilidade e abaixo do limite de tamanho do projeto.
 */
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => {
  const dark = theme.mode === "dark";
  return {
    root: { width: "100%" },
    hint: {
      display: "flex",
      alignItems: "flex-start",
      gap: theme.spacing(1),
      padding: theme.spacing(1.25, 1.5),
      borderRadius: 12,
      marginBottom: theme.spacing(2),
      background: dark ? "rgba(91, 124, 255, 0.08)" : "rgba(61, 92, 253, 0.05)",
      border: dark
        ? "1px solid rgba(91, 124, 255, 0.18)"
        : "1px solid rgba(61, 92, 253, 0.12)",
      color: dark ? "rgba(255, 255, 255, 0.72)" : "#475569",
      fontSize: "0.8rem",
      lineHeight: 1.5,
      "& svg": { color: dark ? "#7c9bff" : "#3D5CFD", flexShrink: 0, marginTop: 1 },
    },
    empty: {
      textAlign: "center",
      color: dark ? "rgba(255, 255, 255, 0.35)" : "rgba(15, 23, 42, 0.4)",
      fontSize: "0.85rem",
      lineHeight: 1.5,
      padding: theme.spacing(3, 2),
      border: dark
        ? "1px dashed rgba(255, 255, 255, 0.12)"
        : "1px dashed rgba(15, 23, 42, 0.12)",
      borderRadius: 12,
      marginBottom: theme.spacing(2),
    },
    card: {
      borderRadius: 14,
      padding: theme.spacing(1.75, 2),
      marginBottom: theme.spacing(1.5),
      background: dark ? "rgba(255, 255, 255, 0.035)" : "rgba(15, 23, 42, 0.02)",
      border: dark
        ? "1px solid rgba(255, 255, 255, 0.09)"
        : "1px solid rgba(15, 23, 42, 0.08)",
    },
    cardError: {
      border: dark
        ? "1px solid rgba(239, 68, 68, 0.4)"
        : "1px solid rgba(239, 68, 68, 0.35)",
    },
    header: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: theme.spacing(1),
      marginBottom: theme.spacing(1.25),
    },
    quickActions: { display: "flex", gap: theme.spacing(0.75), flexWrap: "wrap" },
    quickBtn: {
      border: "none",
      cursor: "pointer",
      padding: "4px 10px",
      borderRadius: 8,
      fontSize: "0.72rem",
      fontWeight: 600,
      fontFamily: "inherit",
      background: dark ? "rgba(91, 124, 255, 0.16)" : "rgba(61, 92, 253, 0.08)",
      color: dark ? "#a5b4fc" : "#3D5CFD",
      transition: "all 0.15s",
      "&:hover": {
        background: dark ? "rgba(91, 124, 255, 0.26)" : "rgba(61, 92, 253, 0.15)",
      },
    },
    daysRow: {
      display: "flex",
      flexWrap: "wrap",
      gap: theme.spacing(0.75),
      marginBottom: theme.spacing(1.5),
    },
    dayChip: {
      fontWeight: 600,
      fontSize: "0.75rem",
      height: 30,
      cursor: "pointer",
      transition: "all 0.15s",
    },
    dayChipOn: {
      background: dark ? "rgba(91, 124, 255, 0.9) !important" : "#3D5CFD !important",
      color: "#fff !important",
      border: "none !important",
    },
    dayChipOff: {
      background: "transparent !important",
      color:
        (dark ? "rgba(255,255,255,0.55)" : "rgba(15,23,42,0.45)") + " !important",
      border: dark
        ? "1px solid rgba(255,255,255,0.15) !important"
        : "1px solid rgba(15,23,42,0.15) !important",
    },
    dayChipDisabled: {
      opacity: "0.3 !important",
      cursor: "not-allowed !important",
      pointerEvents: "none",
    },
    fieldLabel: {
      fontSize: "0.72rem",
      fontWeight: 600,
      letterSpacing: "0.02em",
      textTransform: "uppercase",
      color: dark ? "rgba(255,255,255,0.45)" : "rgba(15,23,42,0.45)",
      marginBottom: 2,
      marginTop: theme.spacing(0.5),
    },
    fieldLabelOpt: {
      fontWeight: 500,
      textTransform: "none",
      letterSpacing: 0,
      fontSize: "0.7rem",
      opacity: 0.8,
    },
    timeRow: {
      display: "flex",
      alignItems: "flex-start",
      gap: theme.spacing(1.25),
    },
    timeField: {
      flex: 1,
      "& .MuiInputBase-root": {
        color: dark ? "rgba(255,255,255,0.92)" : "rgba(15,23,42,0.9)",
        background: dark ? "rgba(255,255,255,0.05)" : "transparent",
        borderRadius: 8,
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: dark ? "rgba(255,255,255,0.18)" : "rgba(15,23,42,0.2)",
      },
      "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: dark ? "rgba(255,255,255,0.35)" : "rgba(15,23,42,0.5)",
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: dark ? "#818cf8" : "#3D5CFD",
      },
    },
    timeFieldError: {
      "& .MuiOutlinedInput-notchedOutline": { borderColor: "#ef4444 !important" },
    },
    sep: {
      color: dark ? "rgba(255,255,255,0.3)" : "rgba(15,23,42,0.3)",
      fontWeight: 300,
      fontSize: "1.2rem",
      flexShrink: 0,
      marginTop: 8,
    },
    deleteBtn: {
      color: dark ? "rgba(255,255,255,0.3)" : "rgba(15,23,42,0.25)",
      "&:hover": { color: "#ef4444", background: "rgba(239, 68, 68, 0.08)" },
    },
    errorText: {
      color: "#ef4444",
      fontSize: "0.75rem",
      marginTop: theme.spacing(0.75),
    },
    addBtn: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: theme.spacing(1),
      padding: theme.spacing(1.15, 2),
      borderRadius: 10,
      border: dark
        ? "1.5px dashed rgba(255,255,255,0.2)"
        : "1.5px dashed rgba(15,23,42,0.18)",
      color: dark ? "rgba(255,255,255,0.5)" : "rgba(15,23,42,0.5)",
      cursor: "pointer",
      background: "transparent",
      width: "100%",
      fontSize: "0.875rem",
      fontWeight: 500,
      fontFamily: "inherit",
      transition: "all 0.15s",
      "&:hover": {
        borderColor: dark ? "rgba(91,124,255,0.7)" : "#3D5CFD",
        color: dark ? "#818cf8" : "#3D5CFD",
        background: dark ? "rgba(91,124,255,0.06)" : "rgba(61,92,253,0.03)",
      },
    },
  };
});

export default useStyles;
